<template>
	<div>
		<selectHeader :summary-data="summaryData" />
		<div class="mainArea container-fluid">
			<div class="row">
				<managers class="full-height" @summary="setSummaryData" v-if="pageView === 'managers'" />
				<ManagerComparison class="full-height" v-if="pageView === 'ManagerComparison'" />
				<testTable v-if="pageView === 'testTable'" />
				<div class="full-height chart-div" :class="fullscreenMain" v-show="pageLoaded && ['home', 'search', 'tests'].includes(pageView)">
					<homeChart />
				</div>
				<div
					class="full-height optionsTab col-md-3"
					:class="[fullscreenSide, slideOutStatus]"
					v-if="!['ManagerComparison', 'managers', 'testTable', 'home'].includes(pageView)"
				>
					<div v-if="$store.state.ui.fullScreen" class="slideTab" @click="toggleSlideOut()"></div>
					<searchSidebar class="full-height" v-if="pageLoaded && pageView === 'search'" />
					<testsSidebar class="full-height" @updateValueFilterElement="updateFilter" v-if="pageLoaded && pageView === 'tests'" />
				</div>
			</div>
		</div>
		<selectFooter />
	</div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import homeChart from '@/components/charts/homeChart';
import ManagerComparison from '@/components/pages/managerComparison';
import managers from '@/components/pages/managers';
import searchSidebar from '@/components/common/uiLayouts/searchSidebar';
import selectFooter from '@/components/common/uiLayouts/footer';
import selectHeader from '@/components/common/uiLayouts/header';
import testTable from '@/components/common/uiLayouts/testTable';
import testsSidebar from '@/components/common/uiLayouts/testsSidebar';

export default {
    mixins: [clickaway],
    components: {
        homeChart,
        ManagerComparison,
        managers,
        searchSidebar,
        selectFooter,
        selectHeader,
        testTable,
        testsSidebar,
    },
    data () {
        return {
            data: '',
            showLegends: true,
            slideOutActive: false,
            sortOption: null,
            tableData: [],
            option: {
                itemSelector: '.twenty',
                getSortData: {
                    id: 'id',
                    name (itemElem) {
                        return itemElem.id;
                    },
                },
                masonry: {
                    columnWidth: '.twenty',
                },
                initLayout: false,
            },
            summaryData: [],
            returnVal: [],
            standardDeviationVal: [],
            maxDrawdownVal: [],
            aumVal: [],
            feeVal: [],
            trackRecordVal: [],
        };
    },
    created () {
        const universe = {
            showOptions: false,
            chosenSectors: [],
            dueDilligence: false,
            lcpRating: {
                buy: true,
                hold: true,
                review: true,
                unrated: true,
            },
            openFundsOnly: false,
        };
        this.$store.dispatch('universe/setUniverse', universe);
    },
    methods: {
        toggleSlideOut () {
            this.slideOutActive = !this.slideOutActive;
        },
        getChartHeight () {
            this.$store.commit('chart/updateDimensions', { width: '100%', height: 1200 });
        },
        setSummaryData (value) {
            this.summaryData = value;
            for (let i = 0; i < this.summaryData.length; i += 1) {
                const aum = typeof this.summaryData[i].AUM === 'string' ? this.summaryData[i].AUM : this.summaryData[i].AUM.toFixed(1);
                let fee = '';
                if (this.summaryData[i].Fee !== null) {
                    fee = typeof this.summaryData[i].Fee === 'string' ? this.summaryData[i].Fee : this.summaryData[i].Fee.toFixed(1);
                }
                this.summaryData[i].AUM.toFixed(1);
                this.summaryData[i].Name = this.$store.state.universe.data.keyData[this.summaryData[i].id].name;
                this.summaryData[i]['Max drawdown'] = `${this.summaryData[i]['Max drawdown'].toFixed(1)}%`;
                this.summaryData[i]['Return (% - pa over 1y)'] = `${this.summaryData[i]['Return (% - pa over 1y)'].toFixed(1)}%`;
                this.summaryData[i].AUM = `$${aum}m`;
                this.summaryData[i]['Standard deviation (% pa)'] = `${this.summaryData[i]['Standard deviation (% pa)'].toFixed(1)}%`;
                this.summaryData[i].Fee = `${fee}%`;
                this.summaryData[i]['Length of track record'] = `${this.summaryData[i]['Length of track record'].toFixed(1)} years`;
            }
        },
        updateFilter (change) {
            switch (change.name) {
            case 'Return (% - pa over 1y)':
                this.returnVal = change.newValue;
                break;
            case 'Standard deviation (% pa)':
                this.standardDeviationVal = change.newValue;
                break;
            case 'Max drawdown':
                this.maxDrawdownVal = change.newValue;
                break;
            case 'AUM':
                this.aumVal = change.newValue;
                break;
            case 'Fee':
                this.feeVal = change.newValue;
                break;
            case 'Length of track record':
                this.trackRecordVal = change.newValue;
                break;
            default:
                break;
            }
        },
    },
    mounted () {
        this.getChartHeight();
    },
    computed: {
        fullscreenMain () {
            return this.$store.state.ui.fullScreen ? 'col-md-12' : 'col-md-9';
        },
        fullscreenSide () {
            return this.$store.state.ui.fullScreen ? 'sideFullscreen' : '';
        },
        slideOutStatus () {
            return this.slideOutActive ? 'slideShow' : '';
        },
        fullscreen () {
            return this.$store.state.ui.fullScreen;
        },
        fundTotal () {
            return this.$store.state.chart.visiblePoints.length > 0 ? this.$store.state.chart.visiblePoints.length : 0;
        },
    },
    watch: {
        fullscreen () {
            this.$nextTick(() => {
                this.getChartHeight();
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "src/assets/scss/all.scss";

/*FIX THE SCSS WITH THE IMPROVEMENTS LEARNT*/
$primary-color: #032f5e;
$primary-font: Helvetica, Ariel, Sans-Serif;
.slideTab {
	background: #00a3c4;
	height: 135px;
	left: -15px;
	position: absolute;
	width: 30px;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	z-index: 2;
	top: 50%;
	cursor: pointer;
	.tab {
		padding-top: 8px;
		color: #fff;
		writing-mode: vertical-rl;
		text-orientation: mixed;
		margin-left: 5px;
	}
	.icon-arrow-right {
		color: #fff;
		// position: absolute;
		// right: 0px;
		// top: 50%;
		margin-left: 8px;
	}
}
.sideFullscreen {
	-webkit-transition: all 0.5s ease-out;
	position: absolute !important;
	right: calc(-25% + 15px);
	transition: all 0.5s ease-out;
}
.slideShow {
	-webkit-transition: all 0.5s ease-out;
	right: 0 !important;
	transition: all 0.5s ease-out;
}
.all-buttons {
	background-color: $primary-color;
	border-radius: 20em;
}
/*HEADER*/
#lcp {
	color: #00a3c7;
}
#focus {
	color: #002f5f;
	font-weight: bold;
}
/*HEADER*/

#main {
	/*FOOTER*/
	/******/
	/*HEADER*/
	#focus-header {
		font: {
			family: $primary-font;
			size: 45px;
			weight: 400;
		}
		letter-spacing: normal;
		line-height: 32px;
	}
	/******/
	/*No select in Chart area, popovers or the side nav*/
	.no-selection {
		font-family: $primary-font;
		-webkit-touch-callout: none;
		/* iOS Safari */
		-webkit-user-select: none;
		/* Chrome/Safari/Opera */
		-khtml-user-select: none;
		/* Konqueror */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* Internet Explorer/Edge */
		user-select: none;
		/* Non-prefixed version, currently */
		overflow-x: hidden;
		overflow-y: hidden;
	}
	/******/
	/*side nav header and sub-head*/
	.header,
	li.header {
		background-color: $primary-color;
		color: white;
	}
	.sub-header {
		border-color: 1px solid black;
		color: $primary-color;
	}
	/******/
	/*sub head color for summary*/
	.content-color {
		color: $primary-color;
	}
	/******/
	/*No shadows on side options*/
	.toolbar-no-shadow {
		box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
	}
	/******/
	/* graph font and color*/
	.chartText {
		color: $primary-color;
		fill: $primary-color;
		font-family: $primary-font;
	}
	/******/
	/*Box zoomed in*/
	.zoomedBox {
		stroke-width: 0px;
	}
	/******/
	/*legend button css*/
	.btn.btn--raised {
		@extend .all-buttons;
		margin-bottom: 20px;
	}
	/******/
	/*Legend and filter select menu*/
	.list__tile--link {
		background: white;
		cursor: default;
	}
	div.legend-list {
		a.list__tile {
			background: #ffffff;
			cursor: default;
			text-decoration: none;
		}
		.ripple__animation {
			display: none;
		}
	}
	.legend-list li {
		margin: -10px 0;
	}
	/******/
	/*graph and table position*/
	.table-graph {
		// position: fixed;
		@media (max-width: 994px) {
			position: relative;
		}
	}
	.chart-div {
		@extend .table-graph;
		height: 85vh;
		.fullscreenIcon {
			position: absolute;
			right: 5%;
			top: 0%;
			z-index: 1000;
		}

		.source {
			position: absolute;
			right: 2%;
			bottom: 2%;
		}
	}
	.table-div {
		margin-top: 20px;
		@media (max-width: 994px) {
			height: auto;
		}
		.table-headers {
			color: $primary-color;
			border-radius: 3px;
		}
	}
	.placeholder-col {
		@media (max-width: 994px) {
			display: none;
		}
	}
	table.circleTable {
		border: 2px solid $primary-color;
		thead {
			th {
				font: {
					size: 15px;
					weight: bold;
				}
				&:first-child {
					width: 40%;
				}
				border-color: $primary-color;
				color: $primary-color;
				padding: 10px;
			}
		}
		tbody {
			td {
				border-color: $primary-color;
				color: $primary-color;
				padding: 10px;
				width: 10%;
				&:first-child {
					width: 40%;
					font-weight: bold;
					font-size: 14px;
				}
			}
		}
		tr {
			border-bottom: 2px solid $primary-color;
		}
	}
	/******/
}
/*popover css*/
div.popover {
	@extend .no-selection;
	position: fixed;
	@media (max-width: 994px) {
		position: absolute;
	}
	&:not(.modal *) {
		text-shadow: none;
		opacity: 0.5;
	}
	.arrow {
		border-right-color: $primary-color;
	}
	.btn.btn--raised {
		color: white;
		@extend .all-buttons;
	}
}
/******/
/*document styling*/

.white-background {
	background: #fff;
}
/******/
/*title margin*/
.titles {
	margin-top: 20px;
}
/******/
/*graph*/
#mainChartArea {
	// background-color: #ffffff;
	@extend .no-selection;
	min-height: 560px;
}
.axis {
	line {
		stroke: #000;
		shape-rendering: crispEdges;
	}
	path {
		fill: none;
		stroke: $primary-color;
		stroke-width: 2px;
		shape-rendering: crispEdges;
	}
}
.chartBackground {
	fill: white;
}
.box {
	fill-opacity: 0;
	fill: none;
	&.zoomedIn {
		&.beingCreated {
			stroke: $lightBlue;
		}
	}
	stroke-opacity: 1;
	stroke-width: 2;
	&.zoomedIn {
		stroke: none;
	}
}
.selectedBox {
	fill-opacity: 0;
	filter: alpha(opacity=25);
	/* For IE8 and earlier */
	stroke: red;
}
/******/
/*popover*/
.popover-content {
	background-color: white;
	font-size: inherit;
	max-height: 80vh;
	overflow-y: auto;
	padding: 0px;
	text-shadow: none;
	ul {
		list-style-position: inside;
		padding-left: 0;
	}
}
.popover-title {
	background-color: transparent !important;
	border: none !important;
	padding: 0 14px !important;
}
.mainArea {
	position: relative;
	overflow-x: hidden;
	// padding:1rem 0;
	// overflow-y:visible;
}
.popover {
	.managerCard {
		padding: 10px 6px;
		position: relative;
		width: 260px;
		.managerTitle {
			// white-space: nowrap;
			font-size: 16px;
			font-weight: 600;
			margin-bottom: 0px;
			margin-top: 10px;
			overflow: hidden;
			text-align: left;
			text-overflow: ellipsis;
			width: 100%;
		}
		.sector {
			font-size: 12px;
			margin-bottom: 8px;
			width: 100%;
			.sectorColor {
				border-radius: 6px;
				float: right;
				height: 12px;
				margin-top: 2px;
				width: 12px;
			}
		}
		.stats {
			color: $lightBlue;
			div {
				border-bottom: 1px solid $lightGrey;
				margin-bottom: 2px;
				text-align: right;
				&:last-child {
					border-bottom: none;
				}
				span {
					color: $darkGrey;
					float: left;
					font-weight: 500;
					&.rating {
						background: $LCPMarine;
						border-radius: 6px;
						color: white;
						cursor: pointer;
						display: inline-block;
						float: none;
						text-align: center;
						width: 20px;
					}
					&.increase {
						margin-left: 5px;
					}
					&.decrease {
						margin-right: 5px;
					}
					&.currentRating {
						display: inline-block;
						float: none;
					}
				}
			}
			.topTrump {
				background-color: $darkBlue;
				color: white;
				margin: 0 -5px;
				padding: 0 5px;
				span {
					color: white;
				}
			}
		}
		.addFund {
			background-color: $darkBlue;
			border-radius: 6px;
			color: white;
			cursor: pointer;
			margin-top: 14px;
			padding: 5px;
			text-align: center;
			width: 100%;
		}
		.removeFund {
			background-color: #9f0000;
			border-radius: 6px;
			color: white;
			cursor: pointer;
			margin-top: 14px;
			padding: 5px;
			text-align: center;
			width: 100%;
		}
	}
}

.fund-total {
	position: absolute;
	right: 20px;
	top: 0px;
	.inputTitle {
		color: $darkBlue;
		font-size: 18px;
		font-weight: 700;
	}
}
/******/
</style>
